<template>
    <loading></loading>
</template>

<script>
    import Vue from 'vue'
    import Loading from "./common/Loading";

    let frc = Vue.prototype.$frc;
    export default {
        name: "Logout",
        components: {Loading},
        mounted() {
            frc.logoutKeycloak(Vue.prototype.$appBasePath);
            document.cookie = "current-ward=; Max-Age=0";
        }
    }
</script>

<style scoped>

</style>